import * as React from 'react';
import { Popper, PopperProps } from 'MaterialUIComponents';

const CustomPopper = (props: PopperProps) => {
    return <Popper {...props} style={{ width: 'fit-context' }} placement="bottom-start" />;
};

export default CustomPopper;
